import * as React from 'react';

import { cn } from '@blockworks/ui/utils';

import ButtonLink from '@/components/display/buttons/button-link';
import type ButtonProps from '@/components/display/buttons/type/button-props';

const PrimaryButton = (props: ButtonProps) => {
    return (
        <ButtonLink
            {...props}
            className={cn(
                'bg-brand text-white border border-transparent hover:border-brand hover:bg-white hover:text-brand',
                props.className,
            )}
        >
            {props.children}
        </ButtonLink>
    );
};

export default PrimaryButton;
